var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',_vm._b({attrs:{"number-to-display":5,"heading":"Trends","heading-color":"var(--pcr-hdr-2-color)","hide-default-bg-image":"","trend-colors":[
    'var(--pcr-1-color)',
    'var(--pcr-2-color)',
    'var(--pcr-3-color)' ]}},'page',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }